import { Switch } from "antd";
import React, { ChangeEvent } from "react";

type Permission = {
  read: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
};

type ModulePermission = {
  moduleId: string;
  permissions: Permission;
};

type Module = {
  id: string;
  name: string;
  key: string;
  description: string;
};

type Props = {
  modules: any;
  modulePermissions: any;
  onUpdate: (updated: any) => void;
};

const PermissionsEditor: React.FC<Props> = ({
  modules,
  modulePermissions,
  onUpdate,
}) => {
  const handleToggle = (moduleId: string, enabled: boolean) => {
    if (enabled) {
      // Add default permissions
      onUpdate([
        ...modulePermissions,
        {
          moduleId,
          permissions: {
            read: false,
            create: false,
            update: false,
            delete: false,
          },
        },
      ]);
    } else {
      // Remove module from permissions
      onUpdate(
        modulePermissions.filter((perm: any) => perm.moduleId !== moduleId)
      );
    }
  };

  const handleCheckboxChange = (
    moduleId: string,
    permissionKey: keyof Permission,
    checked: boolean
  ) => {
    const updated = modulePermissions.map((perm: any) => {
      if (perm.moduleId === moduleId) {
        return {
          ...perm,
          permissions: {
            ...perm.permissions,
            [permissionKey]: checked,
          },
        };
      }
      return perm;
    });
    onUpdate(updated);
  };

  return (
    <div>
      {modules.map((item: any) => {
        const modulePermission = modulePermissions.find(
          (perm: any) => perm.moduleId === item.id
        );
        const isEnabled = !!modulePermission;

        return (
          <div key={item.key}>
            <div className="flex justify-between items-center p-4 border-b border-[#EEEEEE]">
              <h3>{item.name}</h3>
              <Switch
                checked={isEnabled}
                onChange={(val: boolean) => handleToggle(item.id, val)}
              />
            </div>

            {isEnabled && (
              <div className="flex gap-4 justify-end mr-4 py-4">
                {["read", "create", "update", "delete"].map((permission) => (
                  <label className="flex items-center gap-2" key={permission}>
                    <span>
                      Can{" "}
                      {permission.charAt(0).toUpperCase() + permission.slice(1)}
                    </span>
                    <input
                      type="checkbox"
                      checked={
                        modulePermission?.permissions?.[
                          permission as keyof Permission
                        ] || false
                      }
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleCheckboxChange(
                          item.id,
                          permission as keyof Permission,
                          e.target.checked
                        )
                      }
                    />
                  </label>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PermissionsEditor;
